/**
 * Points Balance Component
 * Handles the display and functionality of the points balance in the header
 */

class PointsBalance {
  constructor() {
    this.init();
  }

  init() {
    // Wait for Yotpo/Swell to load
    this.waitForSwell();
  }

  waitForSwell() {
    const maxAttempts = 50; // 5 seconds max wait
    let attempts = 0;

    const checkSwell = () => {
      attempts++;

      // Check if Swell is loaded
      if (window.SwellAPI || window.swell) {
        this.setupPointsBalance();
        return;
      }

      // Check if the swell-point-balance element exists and has been populated
      const pointsElement = document.querySelector(".swell-point-balance");
      if (
        pointsElement &&
        pointsElement.textContent.trim() !== "..." &&
        pointsElement.textContent.trim() !== "0"
      ) {
        this.setupPointsBalance();
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(checkSwell, 100);
      } else {
        console.warn("Swell points balance failed to load");
        this.showFallback();
      }
    };

    checkSwell();
  }

  setupPointsBalance() {
    const pointsElement = document.querySelector(".swell-point-balance");
    if (pointsElement) {
      // Remove loading state
      pointsElement.removeAttribute("data-loading");

      // Remove loading animation
      const loadingElement = pointsElement.querySelector(".points-loading");
      if (loadingElement) {
        loadingElement.remove();
      }

      // Add loaded class for styling
      pointsElement.classList.add("points-loaded");
    }
  }

  showFallback() {
    const pointsElement = document.querySelector(".swell-point-balance");
    if (pointsElement) {
      pointsElement.removeAttribute("data-loading");
      pointsElement.textContent = "0";
      pointsElement.classList.add("points-fallback");
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new PointsBalance());
} else {
  new PointsBalance();
}
